export class EnvelopeFile {
    id: number;
    suffixBucketName: string;
    name: string;
    content: Uint8Array;
    fileSize: number;
    widthInMm: number;
    heightInMm: number;
    upload: boolean;
    checked: boolean;
    isRejected: boolean;
    envelopeRejectedHistory: any;
    fileAlreadySigned: boolean;
}
